import { Box } from "@mui/material";
import { LocationDto } from "../locations/LocationDtos";
import { useQueryEntrances } from "./EntrancesQuery";

interface EntrancesListProps {
    locationId?: number,
    selectLocation: (l: LocationDto | null) => void
}

const EntrancesList = (props: EntrancesListProps) => {


    let { data: entrances, isLoading } = useQueryEntrances(props.locationId);

    if (isLoading)
        return null;

    return <Box display="flex" flexDirection={"column"} marginLeft={5}>
        <h2>Entrances</h2>
        {entrances.map(e => {
            return <Box display={"flex"} flexDirection={"row"} borderTop={"1px solid white"} borderBottom={"1px solid white"} sx={{ borderCollapse: "collapse" }} >
                <Box display={"flex"} width={150} onClick={() => props.selectLocation(e.fromLocation)} sx={{ cursor: "pointer" }}>
                    {e.fromLocation.name}
                </Box>
                <Box display={"flex"} width={50}>
                    to
                </Box>
                <Box display={"flex"} marginLeft={5} width={200} onClick={() => props.selectLocation(e.toLocation)} sx={{ cursor: "pointer" }}>
                    {e.toLocation.name}
                </Box>
                <Box display={"flex"} marginLeft={5}>
                    {e.logic}
                </Box>
            </Box>
        })}
    </Box>
}

export default EntrancesList